module.exports = __webpack_public_path__ + "static/media/aakashNewLogo.d49236d5.svg";